module.exports = __webpack_public_path__ + "static/media/icon-world.576de8c0.svg";